import React from 'react';
import { findDOMNode } from 'react-dom';
import {
  Row, Col, Button, Spin
} from 'antd';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import LazyLoad from 'react-lazy-load';
import uniqueId from 'lodash/uniqueId';
import Tab from './tab/index';
import Cards from './cards/index';
import AppShare from '../util/AppShare';
import pageImg from '../../style/img/page.png';
import mainImg2 from '../../style/img/apply2.png';
import AppApplyModal from '../util/AppApplyModal';
import NavLeftSingle from './navigation/NavLeftSingle';
import NavRight from './navigation/NavRight';
import peopleImg from '../../style/img/icon_m_wev8.jpg';//暂时使用
import OldApply from '../oldApply/Apply';
import AppList from '../mode/AppList';
import commonAppImg from '../../style/img/commonApp.png';
import util from '../../util';
const { isWeaver } = util;
const isweaver = isWeaver();

const store = [
  'collectStore',
  'homeStore',
  'initStore',
  'themeListStore',
  'oldApplyStore',
  
]

@inject(...store)
@observer
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubTitleNum: 1,
      showSubTitle: 0,
      showDropdown: false,
    }
  }

  componentDidMount() {
    const { homeStore } = this.props;
    const {callCategoryData, getLastestShare} = homeStore;
    // callCategoryData();
    // getLastestShare();
  }

  collect(v, type) {
    if (!isweaver) return;
    const {homeStore} = this.props;
    let param = {s_ids: v.sw_id};
    if (v.tms_iscoll === '1') homeStore.callCollect(param, type, 'collect');
    else homeStore.callCollect(param, type, 'remove');
  }

  apply(v) {
    if (!isweaver) return;
    const {homeStore} = this.props;
    let param = {sw_id: v.sw_id, s_id: v.s_id};
    let appInfo = [];
    appInfo.push({appId: v.s_number, appName: v.s_name});
    homeStore.callApply(param, appInfo);
  }

  openForm(e, item) {
    // window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + item.s_wfid);
    e && e.stopPropagation && e.stopPropagation();
    e && e.preventDefault && e.preventDefault();
    e && e.nativeEvent && e.nativeEvent.preventDefault();
  }

  render() {
    const server = window.server;
    const {homeStore, initStore } = this.props;
    const {showSubTitle, showSubTitleNum } = this.state;

    //--------------------------------------立即使用[区分登录前后跳转]-----------------------------------------------
    let {me} = initStore;
    me = !!localStorage.me ? JSON.parse(localStorage.me) : {role: ""};
    let isLogin = (me && null !== me.com && "" !== me.com && me.member && null !== me.member.m_name) ? true : false;
    //--------------------------------------------------------------------------------------------------------------

    let {
      routing, categoryDatas, type, appHot
      , tradeApplication, appHotSelected, applyModal
      , applyApps, appShare, lastestShare, functionDatas
    } = homeStore;
    categoryDatas = toJS(categoryDatas);
    functionDatas = toJS(functionDatas);
    appHot = toJS(appHot);
    applyApps = toJS(applyApps);
    tradeApplication = toJS(tradeApplication);
    return (
        <div style={{paddingTop: 57}}>
        <Row
          className={`home-page ${type.id === 'portal' && 'home-page-portal'} ${type.id === 'workflow' && 'home-page-workflow'}`}>
          <Col span={3} offset={2} className='home-page-navigation'>
            <div className='home-page-title'>
              <img src={pageImg} alt=''/>
              <span style={{fontFamily: 'PingFang-SC-Medium'}}>{this.props.type.name}</span>
            </div>
            <div className='home-page-content' onMouseOut={() => {
              this.setState({showSubTitle: 0});
            }}>
              {
                type.id === 'workflow' && categoryDatas[0] && categoryDatas[0].data.map((obj, index) => {
                  return (
                    <NavLeftSingle datas={toJS(obj)}
                                  key={obj.key}
                                  showSubTitle={showSubTitle === 1}
                                  onMouseOver={() => {
                                    let subNavigationTemp = obj.data.map(item => {
                                      return (
                                        <div key={'trade_' + item.key + uniqueId(`trade`)}
                                              className='subnavigation-content'
                                              onClick={() => {
                                                routing.push({
                                                  pathname: '/app/list',
                                                  query: {
                                                    id: type.id,
                                                    radioType: obj.key,
                                                    radioItem: item.key,
                                                  }
                                                });
                                              }}
                                        >{item.name}</div>
                                      )
                                    })
                                    homeStore.subNavigation = subNavigationTemp;
                                    if (showSubTitleNum !== 1) homeStore.navPage = 1;
                                    this.setState({showSubTitle: 1, showSubTitleNum: 1});
                                  }}
                                  onClick={(data) => {
                                    routing.push({
                                      pathname: '/app/list',
                                      query: {
                                        id: type.id,
                                        radioType: obj.key,
                                        radioItem: data.key,
                                      }
                                    });
                                  }}/>
                  )
                })
              }
              {
                type.id === 'workflow' && functionDatas.data.length !== 0 && categoryDatas[0]
                && categoryDatas[0].data.map((obj, index) => {
                  return (
                    <NavLeftSingle datas={functionDatas}
                                  key={obj.key}
                                  showSubTitle={showSubTitle === 2}
                                  onMouseOver={() => {
                                    //-----------------------职能导航右侧数据------------------//
                                    let subNavigationTemp = obj.data.map(v => {
                                      let temp = v.funcList.map((item, index) => {
                                        return (
                                          <div key={'func_' + item.g_id}
                                                className='subnavigation-content subnavigation-contentl'
                                                onClick={() => {
                                                  routing.push({
                                                    pathname: '/app/list',
                                                    query: {
                                                      id: type.id,
                                                      radioType: obj.key,
                                                      radioItem: item.g_tradeid,
                                                      radioSubItem: item.g_id,
                                                    }
                                                  });
                                                }}
                                                onMouseOver={(e) => {
                                                  homeStore.functionSelected = item.g_id;
                                                }}
                                          >
                                            {item.g_name}
                                            <span className='subnavigation-content-sub'>（{v.name}）</span>
                                          </div>
                                        )
                                      });
                                      return temp;
                                    });
                                    let Sum = [];
                                    subNavigationTemp.forEach(v => {
                                      Sum = Sum.concat(v);
                                    });
                                    //-----------------------------------------------------------//
                                    homeStore.subNavigation = Sum;
                                    if (showSubTitleNum !== 2) homeStore.navPage = 1;
                                    this.setState({showSubTitle: 2, showSubTitleNum: 2});
                                  }}
                                  onClick={(data) => {
                                    routing.push({
                                      pathname: '/app/list',
                                      query: {
                                        id: type.id,
                                        radioType: obj.key,
                                        radioItem: data.g_tradeid,
                                        radioSubItem: data.g_id,
                                      }
                                    });
                                  }}
                    />
                  )
                })
              }
            </div>
          </Col>
          <NavRight showSubTitle={showSubTitle}
                    onMouseOver={() => {
                      this.setState({showSubTitle: showSubTitleNum});
                    }}
                    onMouseOut={() => {
                      this.setState({showSubTitle: 0});
                    }}/>
        </Row>
        <Row className='home-page-users'>
          <Col span={10} offset={2} style={{paddingTop: 10}}>
            <span className='users-text'>{homeStore.userCount}</span>
            <span className='users-text'>个用户正在使用</span>
          </Col>
          <Col span={10} style={{textAlign: 'right'}}>
            <Button type='primary' className='users-btn' disabled={!isweaver}
                    onClick={() => {
                      if (!isLogin) routing.push('/login');
                      else routing.push({
                        pathname: '/app/list',
                        query: {id: type.id,}
                      });
                    }}>立即使用</Button>
            <Button type='primary' className='users-btn' disabled={!isweaver}
                    onClick={() => {
                      homeStore.appShare = {...appShare, visible: true};
                    }}>立即分享</Button>
          </Col>
        </Row>
        <div className='apphot'>
          <Tab title={type.id === 'workflow' ? '热门表单' : '热门应用'}
               getMore={() => {
                 routing.push({
                   pathname: '/app/list',
                   query: {id: type.id,}
                 });
               }}
          />
          <Row>
            <Col span={20} offset={2} className='apphot-content' onMouseOut={() => {
              homeStore.appHotSelected = '';
            }}>
              {
                appHot && appHot.map((item, index) => {
                  if (index < 5)
                    return (
                      <div
                        className={`app-content-single ${item.sw_id === appHotSelected && 'app-content-single-hover'}`}
                        key={item.sw_id}
                        onMouseOver={(e) => {
                          homeStore.appHotSelected = item.sw_id;
                          e.stopPropagation && e.stopPropagation();
                          e.preventDefault && e.preventDefault();
                          e.nativeEvent && e.nativeEvent.preventDefault();
                        }} onMouseOut={() => {
                        this.setState({showDropdown: false});
                      }}>
                        <div className='app-content-single-con'>
                          <div className='app-content-single-img-con'>
                            <img onError={(e) => { e.target.onerror = null; e.target.src = commonAppImg; }} src={`${item.s_pictureNati ? server + item.s_pictureNati : commonAppImg}`} alt='' onClick={(e) => {
                              this.openForm(e, item);
                            }}/>
                          </div>
                          <div className='app-content-single-name' title={item.s_name} onClick={(e) => {
                            this.openForm(e, item);
                          }}>
                            {item.s_name}</div>
                          <div className='app-content-single-btns'>
                            <div className='app-content-single-btns' hidden={appHotSelected !== item.sw_id}
                            >
                              <span className='app-content-single-btn' style={{cursor:'not-allowed'}} onClick={(e) => {
                                this.openForm(e, item);
                              }}>预览</span>
                              <span className={`app-content-single-btn ${!isweaver && 'cs-btn-disabled'}`} onClick={() => {
                                this.apply(item);
                              }}>申请</span>
                              <span className={`app-content-single-btn ${!isweaver && 'cs-btn-disabled'}`} onClick={() => {
                                this.collect(item, 'appHot');
                              }}>{item.tms_iscoll === '1' ? '收藏' : '取消收藏'}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                })
              }
            </Col>
          </Row>
        </div>
        <div className='application' style={{padding: '30px 0'}}>
          <Tab
            title={type.id === 'workflow' ? '行业表单' : '行业应用'}
            tabs={tradeApplication.tabs && tradeApplication.tabs.slice(0, 6)}
            showTabs={true}
            selectedKey={tradeApplication.selectedKey}
            onMouseOver={(key) => {
              tradeApplication.data && tradeApplication.data.map((o, i) => {
                if (o.key === key) homeStore.tradeAppData = o.data;
              })
              homeStore.tradeApplication = {...tradeApplication, selectedKey: key};
            }}
            getMore={() => {
              routing.push({
                pathname: '/app/list',
                query: {
                  id: type.id,
                  radioType: tradeApplication.key,
                  radioItem: tradeApplication.selectedKey,
                }
              });
            }}
          />
          <Row>
            <Col span={20} offset={2}>
              <Cards mainImg={mainImg2}
                     data={tradeApplication.data && tradeApplication.data.length > 0 ? tradeApplication.data[0].data
                       : homeStore.tradeAppData.length > 0 ? homeStore.tradeAppData : []}
                     onOpen={(item) => {
                       this.openForm(window.event, item);
                     }}
                     onClick={(item) => {
                       this.openForm(window.event, item);
                     }}
                     onCollect={(item) => {
                       this.collect(item, 'category');
                     }}
                     previewDisable
                     onApply={(item) => {
                       this.apply(item);
                     }}/>
            </Col>
          </Row>
        </div>
        <div style={{padding: '30px 0'}}>
          <Tab title={'最新分享'}
               getMore={() => {
                 routing.push({
                   pathname: '/app/reward',
                   query: {
                     id: type.id,
                   }
                 });
               }}
          />
          <Row>
            <Col span={20} offset={2}>
              <div className='home-page-reward'>
                {
                  lastestShare && lastestShare.map((item, index) => {
                    return (
                      <Row className='home-page-reward-sub' key={'lastestShare' + index}>
                        <Col span={4}>
                          <div className='home-page-reward-con'>
                            <span className={'home-page-reward-rank' + index}>{index + 1}</span>
                            <img src={peopleImg} alt=''/>
                          </div>
                          <span className='home-page-reward-con-span'>{item.memberName}</span>
                        </Col>
                        <Col span={3}>
                          <span>{item.department}</span>
                        </Col>
                        <Col span={3}>
                          <span>{item.branch}</span>
                        </Col>
                        <Col span={6}>
                          <span>总共分享了{item.count}个表单</span>
                        </Col>
                        <Col span={5}>
                          <span>总共奖励:{item.bonus}</span>
                        </Col>
                        <Col span={3} style={{textAlign: 'right'}}>
                          <span>{item.time}</span>
                        </Col>
                        <div className='clearBoth'></div>
                      </Row>
                    )
                  })
                }
              </div>
            </Col>
          </Row>
        </div>
        <AppApplyModal applyModal={applyModal}
                       applyApps={applyApps}
                       handleCloseModal={() => {
                         homeStore.applyModal = {...applyModal, visible: false}
                       }}
        />
        <AppShare/>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/OtherPage.js